export default[
  {
    path: '/brightnessQ',
    name: 'brightnessQ',
    meta: {
      title: '启辉',
    },
    component: () => import('@/view/logo/i-q1')
  },
  {
    path: '/brightnessQT',
    name: 'brightnessQT',
    meta: {
      title: '启辉',
    },
    component: () => import('@/view/logo/i-q2')
  }
]
